export default __webpack_public_path__ + "static/media/sportsbra-medium-back.597496c1.jpg";